import { render, staticRenderFns } from "./SubcategoryButton.vue?vue&type=template&id=0f50d87c"
import script from "./SubcategoryButton.vue?vue&type=script&lang=js"
export * from "./SubcategoryButton.vue?vue&type=script&lang=js"
import style0 from "./SubcategoryButton.vue?vue&type=style&index=0&id=0f50d87c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports